module.exports = __webpack_public_path__ + "static/media/travel.49a324d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/travel.png
// module id = 1799
// module chunks = 50